import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faUserPlus, faTicketAlt, faChartLine } from '@fortawesome/free-solid-svg-icons';
import IconaGioco, { esisteIcona } from './IconeGioco';
import { percorsoDiVoce } from '../../../../utils/giochi';

const MENU_ICONS = {
  users: faUsers,
  userPlus: faUserPlus,
  ticketAlt: faTicketAlt,
  chartLine: faChartLine,
};

/* La regola del percorso sta in utils/giochi.js: la usa anche il foglio
   dei giochi che si apre dalla barra in basso. */
const percorsoDi = percorsoDiVoce;

function Item({ menu, imgUrl, path }) {
  const navigate = useNavigate();

  /* QUALE VOCE E' ACCESA LO DICE L'INDIRIZZO, e basta.
     Prima era uno stato, tenuto allineato da due effetti. Il secondo lo
     rimetteva a -1 ed era scritto con `homePage` fra le dipendenze: quella
     arriva come funzione creata da capo a ogni ridisegno, quindi l'effetto
     ripartiva ogni volta e spegneva la voce appena accesa. Risultato:
     cliccavi Sport e non si colorava niente.
     Ricavandolo dall'indirizzo non c'e' piu' niente da tenere allineato. */
  /* Anche le pagine sotto una sezione la tengono accesa: la pagina di un
     gioco (/casino/gioco/…) e' ancora Casino'. La Home ('/') solo da sola. */
  const attivo = React.useMemo(() => {
    if (!path) return -1;
    const esatto = menu.findIndex((item) => percorsoDi(item) === path);
    if (esatto >= 0) return esatto;
    return menu.findIndex((item) => percorsoDi(item) !== '/' && path.startsWith(percorsoDi(item) + '/'));
  }, [menu, path]);

  const activeMenuItem = (index, item) => {
    navigate(percorsoDi(item));
  };

  const baseUrl = (typeof imgUrl === 'string' ? imgUrl : '') || (typeof process !== 'undefined' && process.env && process.env.PUBLIC_URL) || '';

  return (
      <>
        {menu.map((item, index) => {
          const imgName = typeof item.img === 'string' ? item.img : null;
          const faIcon = typeof item.icon === 'string' ? MENU_ICONS[item.icon] : null;
          return (
            <div
                key={`${item.path || item.name || index}-${index}`}
                onClick={() => activeMenuItem(index, item)}
                className={'menu-item flex' + (index === attivo ? ' activeElement' : '')}
            >
              {faIcon ? (
                  <>
                    <FontAwesomeIcon icon={faIcon} className="menu-icon" />
                    <p className="menu-text uppercase">{item.name}</p>
                  </>
              ) : imgName && esisteIcona(imgName) ? (
                  /* Icona disegnata dentro la pagina: prende il colore della
                     voce da sola, senza il filtro hue-rotate che riscriveva
                     a mano il colore dell'accento. */
                  <>
                    <IconaGioco nome={imgName} className="menu-icon" />
                    <p className="menu-text uppercase">{item.name}</p>
                  </>
              ) : imgName ? (
                  /* Ripiego per una voce che un'icona disegnata non ce l'ha:
                     resta il file di prima, com'era. */
                  <>
                    <img src={`${baseUrl}/assets/${imgName}.svg`}
                         alt={item.name || ''}
                         className="menu-icon immagine"
                         onError={(e) => { e.target.style.display = 'none'; }}
                    />
                    <p className="menu-text uppercase">{item.name}</p>
                  </>
              ) : (
                  <div className={'menu-item-bottom'}>
                    <p className="menu-text">{item.name}</p>
                  </div>
              )}
            </div>
          );
        })}
      </>
  );
}

function MenuItem({ host, menu, imgUrl, path }) {
  return (
      <div className="flex">
        <Item menu={menu} host={host} imgUrl={imgUrl} path={path} />
      </div>
  );
}

export default MenuItem;
